module.exports = __webpack_public_path__ + "static/media/YM73_0.bd633bdc.jpg";